<template>
  <div>
    <div
      id="seasidetms_row_mhkq428k3"
      class="seasidetms_row seasidetms_color_scheme_default seasidetms_row_top_default seasidetms_row_bot_default seasidetms_row_boxed"
    >
      <div class="seasidetms_row_outer_parent">
        <div class="seasidetms_row_outer">
          <div class="seasidetms_row_inner">
            <div class="seasidetms_row_margin seasidetms_2313">
              <div
                id="seasidetms_column_wcpvshnp5"
                class="seasidetms_column two_third"
              >
                <div class="seasidetms_column_inner">
                  <div
                    id="seasidetms_heading_4r9v8dg6s"
                    class="seasidetms_heading_wrap seasidetms_heading_align_left"
                  >
                    <h2 class="seasidetms_heading">
                      {{ $t('contactsPage.form.header') }}
                    </h2>
                  </div>
                  <div class="seasidetms_contact_form">
                    <div
                      role="form"
                      class="wpcf7"
                      id="wpcf7-f6-p11850-o2"
                      lang="ru-RU"
                      dir="ltr"
                    >
                      <div class="screen-reader-response"></div>
                      <form @submit.prevent="onSubmit" class="wpcf7-form">
                        <div>
                          <p class="input-wrap">
                            <span class="wpcf7-form-control-wrap your-name"
                              ><input
                                type="text"
                                name="your-name"
                                value=""
                                size="40"
                                class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required"
                                aria-required="true"
                                aria-invalid="false"
                                :placeholder="
                                  $t('contactsPage.form.name') + '*'
                                "
                                v-model="name"
                                @blur="$v.name.$touch()"
                              />
                              <div
                                class="error"
                                v-if="$v.name.$dirty && !$v.name.required"
                              >
                                {{ $t('appealForm.emptyName') }}
                              </div></span
                            >
                          </p>
                          <p class="input-wrap" style="margin-left: 20px">
                            <span class="wpcf7-form-control-wrap your-email"
                              ><input
                                type="text"
                                name="your-email"
                                value=""
                                size="40"
                                class="wpcf7-form-control wpcf7-text wpcf7-email wpcf7-validates-as-required wpcf7-validates-as-email"
                                aria-required="true"
                                aria-invalid="false"
                                :placeholder="
                                  $t('contactsPage.form.phone') + '*'
                                "
                                @input="phoneMask()"
                                v-model="phone"
                                @blur="$v.phone.$touch()"
                              />
                              <div
                                class="error"
                                v-if="$v.phone.$dirty && !$v.phone.required"
                              >
                                {{ $t('appealForm.emptyPhone') }}
                              </div>
                              <div
                                class="error"
                                v-if="$v.phone.$dirty && !$v.phone.alpha"
                              >
                                {{ $t('appealForm.invalidPhone') }}
                              </div></span
                            >
                          </p>
                        </div>
                        <p class="text_area_contacts" style="width: 100%">
                          <span class="wpcf7-form-control-wrap your-message">
                            <textarea
                              name="your-message"
                              cols="40"
                              rows="10"
                              class="wpcf7-form-control wpcf7-textarea"
                              aria-invalid="false"
                              :placeholder="$t('contactsPage.form.msg')"
                              v-model="msg"
                            ></textarea>
                          </span>
                        </p>
                        <p v-if="!sent">
                          <input
                            type="submit"
                            :value="$t('contactsPage.form.btn')"
                            class="wpcf7-form-control wpcf7-submit"
                            id="form-buttom-contacts-form"
                          />
                          <span class="ajax-loader"></span>
                        </p>
                        <div class="success-msg" v-else>
                          <p>{{ $t('appealForm.formSent') }}</p>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="seasidetms_column_rkwdoi4tk"
                class="seasidetms_column one_third"
              >
                <div class="seasidetms_column_inner">
                  <div
                    class="seasidetms_sidebar sidebar_layout_11 seasidetms_cust_head_contact"
                  >
                    <div class="cl"></div>
                  </div>
                  <div
                    id="seasidetms_heading_c6fnikmonu"
                    class="seasidetms_heading_wrap seasidetms_heading_align_left"
                  >
                    <h2 class="seasidetms_heading">
                      {{ $t('contactsPage.consultations') }}
                    </h2>
                  </div>
                  <div
                    id="seasidetms_heading_8jxttxx95"
                    class="seasidetms_heading_wrap seasidetms_heading_align_left"
                  >
                    <div class="h5 seasidetms_heading">
                      <a href="tel:+380731430022" class="binct-phone-number-1"
                        ><i
                          class="fa fa-phone"
                          style="margin-right: 5px"
                          aria-hidden="true"
                        ></i
                        >+38 (073) 143-00-22</a
                      >
                    </div>
                  </div>
                  <div
                    id="seasidetms_heading_ou6zht2k5i"
                    class="seasidetms_heading_wrap seasidetms_heading_align_left"
                  >
                    <div class="h5 seasidetms_heading">
                      <a href="tel:+380961430055" class="binct-phone-number-2"
                        ><i
                          class="fa fa-phone"
                          style="margin-right: 5px"
                          aria-hidden="true"
                        ></i
                        >+38 (096) 143-00-55</a
                      >
                    </div>
                  </div>
                  <div
                    id="seasidetms_heading_sgwyggo1zi"
                    class="seasidetms_heading_wrap seasidetms_heading_align_left"
                  >
                    <div class="h5 seasidetms_heading">
                      <a href="mailto:apptown.info@gmail.com"
                        ><i
                          class="far fa-envelope"
                          style="margin-right: 5px"
                        ></i
                        >apptown.info@gmail.com</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, helpers } from 'vuelidate/lib/validators'
export default {
  name: 'Contacts',
  data() {
    return {
      name: '',
      phone: '',
      msg: '',
      sent: false,
    }
  },
  methods: {
    onSubmit() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      } else {
        this.$store
          .dispatch('submitContactForm', {
            name: this.name,
            phone: this.phone,
            message: this.msg,
          })
          .then(() => {
            this.$v.$reset()
            this.sent = true
            this.name = ''
            this.phone = ''
            this.msg = ''
            console.log('*OK')
          })
          .catch(() => {
            console.log('*NOT SUBMITTED')
          })
      }
    },
    phoneMask() {
      const x = this.phone
        .replace(/\D/g, '')
        .match(/(\d{0,3})(\d{0,3})(\d{0,2})(\d{0,2})/)

      this.phone = !x[2]
        ? x[1]
        : '(' +
          x[1] +
          ') ' +
          x[2] +
          (x[3] ? '-' + x[3] : '') +
          (x[4] ? '-' + x[4] : '')
      this.$v.phone.$touch()
    },
  },
  mixins: [validationMixin],
  validations: {
    name: {
      required,
    },
    phone: {
      required,
      alpha: helpers.regex(
        'alpha',
        /\((0)(\d)(\d)\)\s(\d)(\d)(\d)(-)(\d)(\d)(-)(\d)(\d)/i
      ),
    },
  },
}
</script>

<style></style>
